/*
 * lib/export.js
 *
 * Volledige data-export voor de ingelogde user. Eén JSON-bestand, lokaal
 * gedownload via Blob + a.download — geen server-call. Bedoeld als
 * persoonlijke backup voor het geval de Supabase-instance ooit verloren
 * gaat of de gebruiker z'n account verspeelt.
 *
 * Format:
 *   {
 *     florijn_export_version: 1,
 *     exported_at: '2026-06-20T14:32:11.123Z',
 *     username: 'sven',
 *     person: 'sven',
 *     household: { id, name, has_shared_account } | null,
 *     data: {
 *       cats:       state.S.cats,
 *       settings:   state.S.settings,
 *       me:         state.S[meKey],        // jezelf volledig
 *       samen:      state.S.samen | null   // alleen als lid van household
 *     }
 *   }
 *
 * Géén partner-data — die exporteert zelf vanuit z'n eigen account.
 */

import { state } from '../state.js';

const VERSION = 1;

export function buildExportBlob() {
  const meKey = state.user;
  const usernameRaw = state.S[meKey]?.displayName || meKey || 'user';
  const username = String(usernameRaw)
    .toLowerCase()
    .replace(/[^a-z0-9_-]/g, '_') || 'user';

  const payload = {
    florijn_export_version: VERSION,
    exported_at: new Date().toISOString(),
    username,
    person: meKey,
    household: state.householdId
      ? {
          id:                 state.householdId,
          name:               state.householdName || null,
          has_shared_account: !!state.hasSharedAccount,
          mate_connected:     !!state.mateConnected
        }
      : null,
    data: {
      cats:     state.S.cats || [],
      settings: state.S.settings || {},
      me:       state.S[meKey] || null,
      samen:    state.householdId ? (state.S.samen || null) : null
    }
  };

  const json = JSON.stringify(payload, null, 2);
  return new Blob([json], { type: 'application/json' });
}

/** Triggert direct een download. Gebruikt een tijdelijke <a> + Blob URL. */
export function downloadExport() {
  const blob = buildExportBlob();
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement('a');
  a.href     = url;
  const today = new Date().toISOString().slice(0, 10);
  const username = String(state.user || 'user')
    .toLowerCase()
    .replace(/[^a-z0-9_-]/g, '_') || 'user';
  a.download = `florijn-export-${username}-${today}.json`;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }, 0);
}
